module.exports = __webpack_public_path__ + "static/media/default-avatar.39f3e03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default-avatar.png
// module id = 105
// module chunks = 0